import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useFeira } from '../../Contexts/FeiraContext';

const ModalAviso = () => {
  const { modalAviso, setModalAviso } = useFeira();

  const toggle = () => setModalAviso({ ...modalAviso, isOpen: false });

  return (
    <Modal isOpen={modalAviso.isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle} className="bg-light">
        {modalAviso.titulo || "Aviso"}
      </ModalHeader>
      <ModalBody className="py-4">
        <p className="text-center mb-0" style={{ fontSize: '16px' }}>
          {modalAviso.mensagem}
        </p>
      </ModalBody>
      <ModalFooter>
        <Button 
          color="primary" 
          className="w-100" 
          onClick={toggle}
        >
          OK
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalAviso;